import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const BiggestMotivation = lazyWithPreload(
  () => import('./BiggestMotivation'),
)
